<template>
  <g>
    <path
      d="M16 0.298218H2C0.9 0.298218 0 1.19822 0 2.29822V16.2982C0 17.3982 0.9 18.2982 2 18.2982H16C17.1 18.2982 18 17.3982 18 16.2982V2.29822C18 1.19822 17.1 0.298218 16 0.298218ZM16 16.2982H2V2.29822H16V16.2982ZM4 8.29822H14V10.2982H4V8.29822Z"
      fill="#BECED6"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 16.2982H2V2.29822H16V16.2982ZM14 8.29822H4V10.2982H14V8.29822Z"
      fill="white"
    />
  </g>
</template>
